import { CompanyLinkType } from '@api';
import { DotNotationPaths, getValueByPath, useFormatAddress } from '@common';
import { useFormatCategories } from './hooks';

type UseGetRowValuesReturnType = {
  getRowValues: (accessor: DotNotationPaths<CompanyLinkType>) => string | null;
};

export const useGetRowValues = (
  companyLink: CompanyLinkType
): UseGetRowValuesReturnType => {
  const { formatAddressMultiLine } = useFormatAddress();
  const { formatCategories } = useFormatCategories();

  const getRowValues = (accessor: DotNotationPaths<CompanyLinkType>) => {
    const value = (() => {
      switch (accessor) {
        case 'address':
          return formatAddressMultiLine(companyLink.address);
        case 'categories':
          return formatCategories(companyLink.categories);
        default:
          return getValueByPath(companyLink, accessor);
      }
    })();

    return value ? String(value) : null;
  };

  return { getRowValues };
};
